module.exports = __webpack_public_path__ + "h5/img/gong.b378317d.jpg";